import React from 'react';
import ReactConfetti from 'react-confetti';
import useWindowSize from 'react-use/lib/useWindowSize';

export function TutorialConfettiOverlay({ visible }) {
    const { width, height } = useWindowSize();

    if (!visible) return null;

    return (
        <ReactConfetti
            width={width}
            height={height}
            numberOfPieces={400}
            recycle={false}
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 60,
                pointerEvents: 'none',
            }}
        />
    );
}

export default TutorialConfettiOverlay;
